{
  "familyId": "SWW-LEEN-ENG-KOF",
  "questions": [
    {
      "id": "SWW-LEEN-ENG-KOF-001",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'racen'?",
      "context": null,
      "options": ["racete", "racede", "racte", "raasde"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "racen", "stem": "race", "lastLetter": "e", "useTE": true, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "Bij Engelse leenwoorden pas je 't kofschip toe op de KLANK. 'Race' klinkt als 'reis' (s-klank), en s zit in kofschip → -te.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_race",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden — kijk naar de KLANK. Stap 1: De stam van 'racen' is 'race'. Stap 2: 'Race' klinkt als 'reis' (s-klank aan het eind). Stap 3: De s-klank zit WEL in 't kofschip → dus -te. Stap 4: race + te = racete. Checkstrategie: spreek de stam hardop uit en luister naar de laatste klank — zit die in 't kofschip?",
        "solutionSteps": ["Bepaal de stam: racen → race", "Luister naar de KLANK: 'race' klinkt als s-klank", "S-klank zit in 't kofschip → -te", "race + te = racete"],
        "distractorExplanations": {
          "0": "Correct! Kofschip op klank: 'race' klinkt als s-klank (in kofschip) → race + te = racete.",
          "1": "Hier is naar de letter gekeken in plaats van de klank. 'Racede' gebruikt -de, maar de KLANK van 'race' is een s-klank (in kofschip). Dus -te: racete.",
          "2": "De Engelse spelling is hier aangepast. 'Racte' mist de -e van 'race'. De Engelse spelling blijft behouden: race + te = racete.",
          "3": "De spelling is hier 'vernederlandst'. 'Raasde' verandert de spelling van 'race' naar 'raas'. De Engelse spelling blijft behouden: race + te = racete."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.kofschip-letter-not-sound", "label": "Naar letter gekeken i.p.v. klank", "optionIndex": 1 },
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e weggelaten uit stam", "optionIndex": 2 },
          { "id": "sww.loanword-spelling-dutchified", "label": "Engelse spelling vernederlandst", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-002",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Vul in: Gisteren ... ik het bestand naar de cloud. (uploaden)",
      "context": null,
      "options": ["uploadde", "uploadte", "uploade", "upgeload"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "uploaden", "stem": "upload", "lastLetter": "d", "useTE": false, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'upload' eindigt op 'd'. Deze letter staat NIET in 't kofschip, dus: upload + de = uploadde.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_upload",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden. Stap 1: De stam van 'uploaden' is 'upload'. Stap 2: De laatste letter is 'd'. Stap 3: 'd' staat NIET in 't kofschip → dus -de. Stap 4: upload + de = uploadde. Checkstrategie: kijk naar de laatste letter van de stam en controleer of die in 't kofschip staat.",
        "solutionSteps": ["Bepaal de stam: uploaden → upload", "Kijk naar de laatste letter: d", "'d' staat NIET in 't kofschip → -de", "upload + de = uploadde"],
        "distractorExplanations": {
          "0": "Correct! Kofschip: 'd' niet in kofschip → upload + de = uploadde.",
          "1": "Hier is -te gebruikt bij een stam die op d eindigt. 'Uploadte' gebruikt -te, maar 'd' staat NIET in 't kofschip. Dus -de: uploadde.",
          "2": "De verleden tijd is hier verkeerd gevormd. 'Uploade' mist de d van de stam. De stam is 'upload' (met d), dus: upload + de = uploadde.",
          "3": "Hier is het voltooid deelwoord gebruikt zonder hulpwerkwoord. 'Upgeload' is een poging tot voltooid deelwoord. Hier is geen hulpwerkwoord, dus gewoon verleden tijd: uploadde."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verkeerd gekozen (-te i.p.v. -de)", "optionIndex": 1 },
          { "id": "sww.stem-d-lost", "label": "Stam-d weggelaten in uitgang", "optionIndex": 2 },
          { "id": "sww.past-participle-without-aux", "label": "Voltooid deelwoord gebruikt zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-003",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist?",
      "context": null,
      "options": ["We downloadden de app gisteren.", "We downloadten de app gisteren.", "We downloaden de app gisteren.", "We gedownload de app gisteren."],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "downloaden", "stem": "download", "lastLetter": "d", "useTE": false, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'download' eindigt op 'd' (niet in kofschip), dus meervoud verleden tijd: download + den = downloadden.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_download",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden (meervoud). Stap 1: De stam van 'downloaden' is 'download'. Stap 2: De laatste letter is 'd'. Stap 3: 'd' staat NIET in 't kofschip → dus -de(n). Stap 4: 'We' is meervoud: download + den = downloadden.",
        "solutionSteps": ["Bepaal de stam: downloaden → download", "Kijk naar de laatste letter: d (niet in kofschip) → -de(n)", "'We' is meervoud → gebruik -den", "download + den = downloadden"],
        "distractorExplanations": {
          "0": "Correct! Kofschip: 'd' niet in kofschip → download + den = downloadden (meervoud).",
          "1": "Hier is -ten gebruikt bij een stam die op d eindigt. 'Downloadten' gebruikt -ten, maar 'd' staat NIET in 't kofschip. Dus -den: downloadden.",
          "2": "Hier is de tegenwoordige tijd gebruikt in een verleden-tijdcontext. 'Downloaden' is de tegenwoordige tijd. Het signaalwoord 'gisteren' vraagt om verleden tijd: downloadden.",
          "3": "Hier is het voltooid deelwoord gebruikt zonder hulpwerkwoord. 'Gedownload' is het voltooid deelwoord (hoort bij 'hebben gedownload'). Hier is geen hulpwerkwoord, dus gewoon verleden tijd: downloadden."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verwisseld (-ten i.p.v. -den)", "optionIndex": 1 },
          { "id": "sww.tense-signal-ignored", "label": "Signaalwoord 'gisteren' genegeerd, TT gebruikt", "optionIndex": 2 },
          { "id": "sww.past-participle-without-aux", "label": "Voltooid deelwoord gebruikt zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-004",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Vul in: De leraar ... de antwoorden na de toets. (checken, verleden tijd)",
      "context": null,
      "options": ["checkte", "checkde", "gechecked", "gechekt"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "checken", "stem": "check", "lastLetter": "k", "useTE": true, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'check' eindigt op 'k'. De k-klank zit WEL in 't kofschip → -te. check + te = checkte.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_check",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden. Stap 1: De stam van 'checken' is 'check'. Stap 2: De laatste letter/klank is 'k'. Stap 3: 'k' zit WEL in 't kofschip → -te. Stap 4: check + te = checkte. Checkstrategie: bij Engelse leenwoorden dezelfde kofschip-regel toepassen als bij Nederlandse werkwoorden.",
        "solutionSteps": ["Bepaal de stam: checken → check", "Kijk naar de laatste letter: k", "'k' zit in 't kofschip → -te", "check + te = checkte"],
        "distractorExplanations": {
          "0": "Correct! Kofschip: 'k' in kofschip → check + te = checkte.",
          "1": "Hier is -de gebruikt bij een stam die op k eindigt. 'Checkde' gebruikt -de, maar 'k' zit WEL in 't kofschip. Dus -te: checkte. Misconceptie: kofschip verkeerd toepassen.",
          "2": "Hier is de Engelse verleden tijd (-ed) gebruikt. 'Gechecked' mengt Engels en Nederlands. In het Nederlands: stam + kofschip-uitgang = checkte. Misconceptie: Engelse grammatica toepassen.",
          "3": "Hier is het voltooid deelwoord gebruikt. 'Gechekt' is een poging tot VD, maar de vraag vraagt om verleden tijd: checkte."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip verkeerd toegepast (-de i.p.v. -te)", "optionIndex": 1 },
          { "id": "sww.loanword-english-grammar", "label": "Engelse -ed gebruikt i.p.v. Nederlandse uitgang", "optionIndex": 2 },
          { "id": "sww.past-participle-wrong-form", "label": "Voltooid deelwoord i.p.v. verleden tijd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-005",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "fill_in",
      "question": "Wat is de verleden tijd van 'surfen'? (enkelvoud: ik ...) Typ het hele woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["surfte"], "caseSensitive": false, "placeholder": "..." },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'surf' eindigt op 'f'. De f-klank zit WEL in 't kofschip → -te. surf + te = surfte.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_surf_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden. Stap 1: De stam van 'surfen' is 'surf'. Stap 2: De laatste letter is 'f'. Stap 3: 'f' zit WEL in 't kofschip → -te. Stap 4: surf + te = surfte. Checkstrategie: zeg 't kofschip op en controleer of de laatste letter van de stam erin zit.",
        "solutionSteps": ["Bepaal de stam: surfen → surf", "Kijk naar de laatste letter: f", "'f' zit in 't kofschip → -te", "surf + te = surfte"]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Mogelijke fout: 'surfde' (f vergeten in kofschip)" },
          { "id": "sww.loanword-english-grammar", "label": "Mogelijke fout: 'surfed' (Engelse -ed gebruikt)" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-006",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordspellingfouten in deze tekst met Engelse leenwoorden.",
      "context": null,
      "correctAnswer": 0,
      "data": {
        "text": "Wij checkden de score na de wedstrijd. Hij downloadte het bestand snel naar zijn laptop.",
        "errors": [
          { "word": "checkden", "position": 1, "correction": "checkten", "explanation": "Stam 'check' eindigt op k. K zit in kofschip, dus uitgang -ten (meervoud): checkten." },
          { "word": "downloadte", "position": 8, "correction": "downloadde", "explanation": "Stam 'download' eindigt op d. D zit NIET in kofschip, dus uitgang -de: downloadde (dubbel d)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kofschip bij Engelse leenwoorden", "content": "Bepaal de stam (werkwoord min -en, Engelse spelling behouden). Laatste stamletter in kofschip (k, f, s, ch, p, t): -te(n). Andere letter: -de(n).", "icon": "lightbulb" } }
      ],
      "conceptId": "english_loanword_kofschip_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Twee fouten met kofschip bij Engelse leenwoorden. 'Checkden' moet 'checkten' zijn (k in kofschip, dus -ten). 'Downloadte' moet 'downloadde' zijn (d niet in kofschip, dus -de met dubbele d). Vuistregel: kofschip-check op de laatste stamletter, ook bij Engelse leenwoorden.",
        "solutionSteps": [
          "Bepaal de stam (werkwoord min -en)",
          "Laatste stamletter in kofschip? Dan -te(n)",
          "Anders -de(n)",
          "Bij stam op d/t ontstaat dubbele letter"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verwisseld (-den/-ten verwarring)" },
          { "id": "sww.loanword-english-grammar", "label": "Engelse grammatica toegepast op Nederlandse leenwoorden" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-007",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "matching",
      "question": "Koppel elk Engels leenwerkwoord aan de juiste verleden-tijdvorm (enkelvoud).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "checken", "right": "checkte" },
          { "left": "downloaden", "right": "downloadde" },
          { "left": "surfen", "right": "surfte" },
          { "left": "scoren", "right": "scoorde" },
          { "left": "mixen", "right": "mixte" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Strategie",
            "content": "Bepaal de stam, luister naar de eindklank, kofschip-check op klank, plak -te of -de aan de stam. Behoud altijd de Engelse spelling.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "english_loanword_kofschip_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "checken → check + te (k in kofschip) = checkte; downloaden → download + de (d niet in kofschip) = downloadde; surfen → surf + te (f in kofschip) = surfte; scoren → scoor + de (r niet in kofschip) = scoorde; mixen → mix + te (x = ks, s in kofschip) = mixte. Engelse spelling blijft in alle gevallen behouden.",
        "solutionSteps": [
          "Voor elk werkwoord: bepaal de stam",
          "Luister naar de eindklank (let op x = ks)",
          "Kofschip-check op klank",
          "Plak uitgang aan en behoud Engelse spelling"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verwisseld" },
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse stamspelling aangepast" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-008",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "categorize",
      "question": "Sorteer elke verleden-tijdvorm op de juiste uitgang.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Uitgang -te (klank in kofschip)", "Uitgang -de (klank niet in kofschip)"],
        "items": [
          { "text": "checkte", "correctCategory": 0 },
          { "text": "surfte", "correctCategory": 0 },
          { "text": "mixte", "correctCategory": 0 },
          { "text": "racete", "correctCategory": 0 },
          { "text": "downloadde", "correctCategory": 1 },
          { "text": "scoorde", "correctCategory": 1 },
          { "text": "gameden", "correctCategory": 1 },
          { "text": "mailde", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kofschip op klank",
            "content": "-te bij: k, f, s, ch, p, t (én s-klank zoals 'race', ks-klank zoals 'mix'). -de bij: alle andere klanken (r, l, m, n, b, d, g, v, z, etc.).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "english_loanword_kofschip_categorize",
      "variantIndex": 8,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "-te: checkte (k), surfte (f), mixte (ks/s), racete (s-klank). -de: downloadde (d), scoorde (r), gameden (m), mailde (l). Bij Engelse leenwoorden tel je de eindklank van de stam, niet de geschreven letter.",
        "solutionSteps": [
          "Bepaal voor elke vorm de stam",
          "Luister naar de eindklank",
          "Klank in kofschip (k,f,s,ch,p,t-familie) → -te",
          "Andere klank → -de"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.kofschip-letter-not-sound", "label": "Op letter geclassificeerd i.p.v. klank" }
        ]
      }
    }
  ]
}